// extracted by mini-css-extract-plugin
module.exports = {"xs_only":"only screen and (max-width: 767px)","button":"display_toggle__button__IIp0W"};